// BOTON MOBILE

let btnSeeMore = $('.js-state-letters__btn');
btnSeeMore.on('click',function() {
    $('.js-state-letters__list').css({
        'height': 'auto',
    });
    btnSeeMore.hide()
})

